import { IPdfModel } from "../interface/digital-extract/IPdfModel";
import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum PdfModelServiceEnum {
    getAll = "/",
    getById = "/",
    putModel = "/",
    postModel = "/",
    deleteModel = "/"
}

export default class PdfModelService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/models")
    }

    public getAll = (): Promise<IPdfModel[]> => this.GET(PdfModelServiceEnum.getAll);
    public getById = (id): Promise<IPdfModel> => this.GET(PdfModelServiceEnum.getById + id);
    public putModel = (body): Promise<void> => this.PUT(PdfModelServiceEnum.putModel, body);
    public postModel = (body): Promise<void> => this.POST(PdfModelServiceEnum.postModel, body);
    public deleteModel = (id): Promise<any> => this.DELETE(PdfModelServiceEnum.deleteModel + id);
}


// WEBPACK FOOTER //
// ./src/services/api/PdfModel.service.ts